import { TCountry, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../members/axios';

export const getCountriesQueryKey = (includeInactive = false) =>
  ['geography', 'countries', { includeInactive }] as const;

export const useGetCountriesQuery = (includeInactive = false) =>
  useQuery<TCountry[], TError>({
    queryKey: getCountriesQueryKey(includeInactive),
    queryFn: async () => {
      const params = includeInactive ? { includeInactive: true } : undefined;
      const { data } = await axios.get<TCountry[]>('geography/countries', { params });
      return data;
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
